<template>
  <div class="row">
    <div class="col-md-12 card">
      <div id="containerSite"></div>
    </div>
    <div class="col-md-12 card">
      <div id="containerSiteSpouse"></div>
    </div>
    <div class="col-md-12 card">
      <div id="containerSiteMonthly"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      chart: null,
      tableDataCities: null,
      activeCity: "Overall",
      chartSpouse: null,
      chartMonthly: null,
    };
  },
  methods: {
    async callPWID() {
      var dataSeries = [];
      var column = {
        data: [],
      };
      await axios
        .get("sites/byCitiesPWIDSite")
        .then((response) => {
          response.data.forEach((data) => {
            column.name = data.CityShortName;
            if (column.name == "Overall") {
              column.visible = true;
              column.color = "#287161";
            } else {
              column.visible = true;
              column.color = "#287161";
            }
            column.data.push(parseInt(data.ActiveCases));
            column.data.push(parseInt(data.DistinctVCCT));
            column.data.push(parseInt(data.Reactive));
            column.data.push(parseInt(data.RegART));
            column.data.push(parseInt(data.OnART));
            column.data.push(parseInt(data.CompletedAAU));
            column.data.push(parseInt(data.Adherent));
            column.data.push(parseInt(data.ViralLoadTested));
            column.data.push(parseInt(data.ViralLoadSuppressed));

            dataSeries.push(column);
            column = {
              data: [],
            };
          });
          // Call the function for each element in the retrieved data
          dataSeries.forEach(this.colorizeData);
          var highcharts = Highcharts;
          this.chart = highcharts.chart("containerSite", {
            chart: {
              type: "column",
              animation: false,
            },
            title: {
              text: "Cascade of services accessed by active PWID",
            },
            xAxis: {
              categories: [
                "Active<br>Cases",
                "Tested",
                "Reactive",
                "ART<br>Registered",
                "On<br>ART(ARV)",
                "Completed<br>AAU",
                "Adherent",
                "ViralLoad<br>Tested",
                "VL<br>Supressed",
              ],
              labels: {
                useHTML: true,
                style: {
                  fontSize: "8px",
                  wordBreak: "break-all",
                },
              },
              crosshair: true,
            },
            yAxis: {
              stackLabels: {
                style: {
                  fontSize: "2px",
                },
                enabled: false,
              },
              min: 0,
              title: {
                text: "Number of PWID",
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
              },
              color: {
                radialGradient: { cx: 0.5, cy: 0.5, r: 0.5 },
                stops: [
                  [0, "#003399"],
                  [1, "#3366AA"],
                ],
              },
              series: {
                pointPadding: 0,
                groupPadding: 0,
                point: {
                  events: {
                    click: function () {},
                  },
                },
                dataLabels: {
                  enabled: true,
                  style: {
                    fontSize: "8px",
                  },
                  formatter: function () {
                    return Number(this.y).toLocaleString();
                    // return this.y + '<br>' + this.x
                  },
                },
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            series: dataSeries,
          });
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    async callSpouse() {
      // Spouse Chart for COPC
      var dataSeriesSpouse = [];
      var columnSpouse = {
        data: [],
      };
      await axios
        .get("sites/byCitiesSpouseSite")
        .then((response) => {
          response.data.forEach((data) => {
            columnSpouse.name = data.CityShortName;
            if (columnSpouse.name == "All") {
              columnSpouse.visible = true;
              columnSpouse.color = "#287161";
            } else {
              columnSpouse.visible = true;
              columnSpouse.color = "#287161";
            }
            columnSpouse.data.push(parseInt(data.ActiveCases));
            columnSpouse.data.push(parseInt(data.DistinctVCCT));
            columnSpouse.data.push(parseInt(data.Reactive));
            columnSpouse.data.push(parseInt(data.RegART));
            columnSpouse.data.push(parseInt(data.OnART));
            columnSpouse.data.push(parseInt(data.Adherent));
            columnSpouse.data.push(parseInt(data.ViralLoadTested));
            columnSpouse.data.push(parseInt(data.ViralLoadSuppressed));
            dataSeriesSpouse.push(columnSpouse);
            columnSpouse = {
              data: [],
            };
          });

          // Call the function for each element in the retrieved data
          dataSeriesSpouse.forEach(this.colorizeData);
          var highchartSpouse = Highcharts;
          this.chartSpouse = highchartSpouse.chart("containerSiteSpouse", {
            chart: {
              type: "column",
              animation: false,
            },
            title: {
              text: "Cascade of services accessed by active PWID spouses",
            },
            xAxis: {
              categories: [
                "Active<br>Cases",
                "Tested",
                "Reactive",
                "ART<br>Registered",
                "On<br>ART(ARV)",
                "Adherent",
                "ViralLoad<br>Tested",
                "VL<br>Supressed",
              ],
              labels: {
                useHTML: true,
                style: {
                  fontSize: "8px",
                  wordBreak: "break-all",
                },
              },
              crosshair: true,
            },
            yAxis: {
              stackLabels: {
                style: {
                  fontSize: "2px",
                },
                enabled: false,
              },
              min: 0,
              title: {
                text: "Number of PWIDs spouses",
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
              },
              color: {
                radialGradient: { cx: 0.5, cy: 0.5, r: 0.5 },
                stops: [
                  [0, "#003399"],
                  [1, "#3366AA"],
                ],
              },
              series: {
                pointPadding: 0,
                groupPadding: 0,
                style: {
                  fontSize: "8px",
                },
                dataLabels: {
                  enabled: true,
                  style: {
                    fontSize: "8px",
                  },
                },
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            series: dataSeriesSpouse,
          });
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    async callBubbleChart(){
        var dataSeries = [];
        var column = {
            data: [],
        };
        await axios
        .get("sites/bubbleChartDashboardSite")
        .then((response) => {
            response.data.forEach((data) => {
                column.name = data.CityShortName;
            if (column.name == "Overall") {
                column.visible = true;
                column.color = "#287161";
            } else {
                column.visible = true;
                column.color = "#287161";
            }
            column.data.push(parseInt(data.LastMonthAccessDistinct));
            column.data.push(parseInt(data.LastMonthAccess));
            column.data.push(parseInt(data.NSEPContact));
            column.data.push(parseInt(data.SyringeDistributed));
            column.data.push(parseInt(data.TotalSEP));
            column.data.push(parseInt(data.TotalSEPIN));
            column.data.push(parseInt(data.ORW));
            column.data.push(parseInt(data.ContactPerORWs));
            column.data.push(parseInt(data.ContactPerSpots));
            column.data.push(parseInt(data.Spot));
            dataSeries.push(column);
            console.log(dataSeries)
            column = {
              data: [],
            };
          });
          dataSeries.forEach(this.colorizeData);
          var highcharts = Highcharts;
          this.chartMonthly = highcharts.chart("containerSiteMonthly", {
            chart: {
              type: "column",
              animation: false,
            },
            title: {
              text: "Cascade of Past 30 days services",
            },
            xAxis: {
              categories: [
                "Last Month<br>Access Distinct",
                "Last Month<br>Access",
                "NSEP<br>Contact",
                "Syringe<br>Distributed",
                "Total<br>SEP",
                "Total<br>SEP<br>IN",
                "ORW",
                "Contact<br>Per ORWs",
                "Contact<br>Per Spots",
                "Spot",
              ],
              labels: {
                useHTML: true,
                style: {
                  fontSize: "8px",
                  wordBreak: "break-all",
                },
              },
              crosshair: true,
            },
            yAxis: {
              stackLabels: {
                style: {
                  fontSize: "2px",
                },
                enabled: false,
              },
              min: 0,
              title: {
                text: "Count of services",
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
              },
              color: {
                radialGradient: { cx: 0.5, cy: 0.5, r: 0.5 },
                stops: [
                  [0, "#003399"],
                  [1, "#3366AA"],
                ],
              },
              series: {
                pointPadding: 0,
                groupPadding: 0,
                point: {
                  events: {
                    click: function () {},
                  },
                },
                dataLabels: {
                  enabled: true,
                  style: {
                    fontSize: "8px",
                  },
                  formatter: function () {
                    return Number(this.y).toLocaleString();
                    // return this.y + '<br>' + this.x
                  },
                },
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            series: dataSeries,
          });

        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    colorizeData(data) {
      data.color = {
        radialGradient: { cx: 0.5, cy: 0.3, r: 0.7 },
        stops: [
          [0, data.color],
          [1, Highcharts.Color(data.color).brighten(-0.2).get("rgb")], // darken
        ],
      };
    },
  },
  mounted() {
    this.callPWID();
    this.callSpouse();
    this.callBubbleChart();
  },
};
</script>

<style lang="scss" scoped>
    #containerSite {
        height: 500px;
    }
    #containerSiteSpouse {
        height: 500px;
    }
</style>